import { View } from 'react-native'
import { topbar } from '@ui/theme/values'

export default function SpaceTop() {
  return <View style={{ height: topbar.height }} className="w-full" />
}

export function SpaceIntro() {
  return <View style={{ height: 64 }} className="w-full" />
}
